module.exports = __webpack_public_path__ + "static/media/violin.f5e9b5c9.svg";